import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex d-lg-none align-items-center flex-grow-1" }
const _hoisted_2 = {
  class: "btn btn-icon btn-circle btn-active-light-primary ms-n2 me-1",
  id: "kt_aside_toggle"
}
const _hoisted_3 = { class: "svg-icon svg-icon-2x" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  width: "100",
  src: "assets/images/logo_chomtana_erp.png"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs015.svg" })
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "d-lg-none"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
}